const applyPTGrammar = (text) => {
    return text
        .replace(/\bde o\b/g, 'do')
        .replace(/\bde a\b/g, 'da')
        .replace(/\bem o\b/g, 'no')
        .replace(/\bem a\b/g, 'na')    
 }

const applyENGrammar = (text) => {
    return text 
}
 
export const applyGrammar = (text, language) => {
    if (language == 'pt'){
        return applyPTGrammar(text)
    }
    else if (language == 'en'){
        return applyENGrammar(text)
    }
  };